import { Media, Medias } from "../../types/media";

export const checkMediaName = (media: Media, medias: Medias) => {
  if (!media?.name) return false;

  const found = medias.find(
    (mediaFromList) =>
      media.name.trim().toLowerCase() ===
        mediaFromList.name.trim().toLowerCase() && media.id !== mediaFromList.id
  );

  if (found) return true;

  return false;
};

export const checkEmptyMediaName = (media: Media) => {
  const isMediaNameEmpty = !media.name;
  if (isMediaNameEmpty) return true;

  return false;
};

export const validationMessage = (
  media: Media,
  medias: Medias,
  t: (key: string, options?: any) => string
) => {
  const existing = medias.find(
    (m) =>
      m?.name &&
      media.name?.trim().toLowerCase() === m.name.trim().toLowerCase() &&
      media.id !== m.id
  );

  if (existing) {
    return t(`nameAlreadyExistsString`, {
      name: existing.name,
    });
  } else if (checkEmptyMediaName(media)) {
    return t("nameCannotBeEmptyString");
  }
  return "";
};
